import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'
export default class FinancialSustainabilityApi {
    getConfig() {
        const localStorageKeys = Object.keys(localStorage)
        let token = ''

        if (localStorageKeys.includes('usuario')) {
            token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).token : ''
        } else if (localStorageKeys.includes('authentication-admin')) {
            token = localStorage.getItem('authentication-admin') ? JSON.parse(localStorage.getItem('authentication-admin')).token : ''
        }

        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    createFinancialSust(data) {
        return axios.post(`${URL_API}/cadastro/sustentabilidade-financeira/first`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    updateFinancialSust(data) {
        return axios.put(`${URL_API}/sustentabilidade-financeira/update`, data, this.getConfig())
    }

    getFinancialSust() {
        return axios.get(`${URL_API}/sustentabilidade-financeira`, this.getConfig())
    }

    getOrcamentoAnual() {
        return axios.get(`${URL_API}/sustentabilidade-financeira/orcamento-anual`, this.getConfig())
    }

    getMantenhaAtividade() {
        return axios.get(`${URL_API}/sustentabilidade-financeira/mantenha-atividade`, this.getConfig())
    }

    getFaturamentoMensal() {
        return axios.get(`${URL_API}/sustentabilidade-financeira/faturamento-mensal`, this.getConfig())
    }
}



// WEBPACK FOOTER //
// ./src/api/financial-sustainability/FinancialSustainabilityApi.js